import React, { useState, useEffect, useRef, useReducer } from "react";
import axios from "axios";
import { apiPhp, API_URL } from "../../../utils/Common";
import ButtonIconLink from "../../sharecomponents/ButtonIconLink";
import MyLoader from "../../sharecomponents/MyLoader";
import ModalEditarVarColor from "./ModalEditarVarColor";
import Modal from "../../sharecomponents/Modal";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import { Modal as ModalSemantic, Button, Icon } from "semantic-ui-react";


const currentYear = (new Date()).getFullYear();

const initFrmPor = Object.freeze({
   year: '',
});

const initSelectedFlor = Object.freeze({
   florid: "0",
});

const initFrmTipoFlor = Object.freeze({
   variedadId: "0",
   colorId: "0",
});

function reducer( state, action ) {
   switch ( action.type ) {
      case 'close':
         return { open: false }

      case 'open':
         return { open: true, data: action.data }
      
      default:
         throw new Error( 'action no soportada!' );
   }
}

const CatalogoArticulos = (props) => {
   const modalRef = useRef();
   const mdlConfirmRef = useRef();
   // -- loader
   const [loader, updateLoader] = useState(false);
   const [tiposFlor, setTiposFlor] = useState([]); // -- todas las flores
   const [flores, updateFlores] = useState([]);
   const [variedades, setVariedades] = useState([]);
   const [colores, setColores] = useState([]);
   const [selectedFlor, setSelectedFlor] = useState(initSelectedFlor);
   const [frmTipoFlor, setFrmTipoFlor] = useState(initFrmTipoFlor);
   const [tipoFlor, setTipoFlor] = useState({}); // -- una flor seleccionado
   const [frmPor, setFrmPor] = useState( initFrmPor );

   // reducer
   const [ state, dispatch ] = useReducer( reducer, { open: false, data: null } );

   // -- efect
   useEffect(() => {
      getFlores();
      getTiposFlores();
   }, []);

   const handleSelectFlor = (e) => {
      setSelectedFlor({
         ...selectedFlor,
         [e.target.name]: e.target.value,
      });
      axios
         .get(API_URL + "/catalogos/getVariedadesFlor", { params: { florid: e.target.value } })
         .then((r) => {
            setVariedades(r.data.variedades);
         })
         .catch((e) => console.log(e));
   };

   const handleFrmTipoFlor = (e) => {
      setFrmTipoFlor({
         ...frmTipoFlor,
         [e.target.name]: e.target.value,
      });
   };

   const submit = (e) => {
      e.preventDefault();
      if (+selectedFlor.florid !== 0 &&
          +frmTipoFlor.variedadId !== 0 &&
          +frmTipoFlor.colorId !== 0)
      {
         updateLoader(true);
         axios
             .post(API_URL + "/catalogos/setTipoFlor", { ...selectedFlor, ...frmTipoFlor })
             .then((r) => {
                updateLoader(false);
                /*setFrmTipoFlor(initFrmTipoFlor);
                setSelectedFlor(initSelectedFlor);*/
                getTiposFlores();
             })
             .catch((e) => console.log(e));
      } else {
         ToastsStore.error("Seleccione una Flor, Variedad y Color");
      }

   };

   function getFlores() {
      updateLoader(true);
      axios
         .get(API_URL + "/flor/getFlores")
         .then((r) => {
            updateFlores(r.data.flores);
            setColores(r.data.colores);
            updateLoader(false);
         })
         .catch((err) => console.log(err));
   }

   const getTiposFlores = () => {
      updateLoader(true);
      axios
         .get(API_URL + "/catalogos/getTipoFlores")
         .then((r) => {
            setTiposFlor(r.data.tiposflor);
            updateLoader(false);
         })
         .catch((e) => console.log(e));
   };

   const removerTipoFlor = () => {
      axios
         .post(API_URL + "/removerTipoFlor", { tipoFlorId: tipoFlor.id })
         .then((r) => {
            getTiposFlores();
            mdlConfirmRef.current.hideModal();
            ToastsStore.success("Tipo Flor Removido Correctamente!");
         })
         .catch((e) => {
            ToastsStore.error("Error de comunicación con el servidor");
         });
   };

   const goNuevaFlor = () => {
      props.history.push("/nueva_flor");
   };
   // const goColores = () => { props.history.push('/catalogo_colores') }
   const onChangeFrmPor = ($e) => {
      setFrmPor({ ...frmPor, [$e.target.name]:$e.target.value });
   }

   const generarPorcentajes = ( data ) => {
      dispatch({ type: 'close', data: null });

      updateLoader( true );
      apiPhp.post('generar_porcentajes', { ...data, ...frmPor})
         .then(r => {
            updateLoader( false );
         });
   }

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <h5 className="font-bold uppercase text-white">Catálogo de Tipos de Flores</h5>
            </div>
            <div className="p-5 rounded-b">
               {/* ---- CONTENIDO --- */}
               <div className="flex flex-wrap">
                  <div className="w-1/6 px-3">
                     <div className="inline-flex">
                        <button
                           className="bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 mr-5 rounded shadow-lg focus:outline-none mt-8"
                           onClick={goNuevaFlor}
                        >
                           <i className="fas fa-plus mr-3" /> Nueva Flor
                        </button>
                     </div>
                  </div>
                  <div className="w-1/6">
                     <button
                        className="bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 mr-5 rounded shadow-lg focus:outline-none mt-8"
                        onClick={() => {
                           props.history.push("catalogo_flores");
                        }}
                     >
                        Catálogo de Flores
                     </button>
                  </div>
                  <div className="w-4/6 px-4 py-1 border border-orange-300 rounded shadow-xl">
                     <form onSubmit={submit}>
                        <div className="text-sm flex flex-wrap -mx-3 mb-2">
                           <div className="w-1/5 px-3">
                              <label className="block tracking-wide text-gray-700 font-bold mb-2">Flor:</label>
                              <div className="relative">
                                 <select
                                    className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    name="florid"
                                    onChange={handleSelectFlor}
                                 >
                                    <option value="0">Ninguno</option>
                                    {flores.map((f, i) => {
                                       return (
                                          <option key={i} value={f.id}>
                                             {f.nombre_comun}
                                          </option>
                                       );
                                    })}
                                 </select>
                                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg
                                       className="fill-current h-4 w-4"
                                       xmlns="http://www.w3.org/2000/svg"
                                       viewBox="0 0 20 20"
                                    >
                                       <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div className="w-1/5 px-3">
                              <label className="block tracking-wide text-gray-700 font-bold mb-2">Variedad:</label>
                              <div className="relative">
                                 <select
                                    className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    name="variedadId"
                                    onChange={handleFrmTipoFlor}
                                 >
                                    <option value="0">Ninguno</option>
                                    {variedades.map((v, i) => {
                                       return (
                                          <option key={i} value={v.id}>
                                             {v.nombre}
                                          </option>
                                       );
                                    })}
                                 </select>
                                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg
                                       className="fill-current h-4 w-4"
                                       xmlns="http://www.w3.org/2000/svg"
                                       viewBox="0 0 20 20"
                                    >
                                       <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div className="w-1/5 px-3">
                              <label className="block tracking-wide text-gray-700 font-bold mb-2">Color:</label>
                              <div className="relative">
                                 <select
                                    className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    name="colorId"
                                    onChange={handleFrmTipoFlor}
                                 >
                                    <option value="0">Ninguno</option>
                                    {colores.map((c, i) => {
                                       return (
                                          <option key={i} value={c.id}>
                                             {c.color}
                                          </option>
                                       );
                                    })}
                                 </select>
                                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg
                                       className="fill-current h-4 w-4"
                                       xmlns="http://www.w3.org/2000/svg"
                                       viewBox="0 0 20 20"
                                    >
                                       <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div className="w-1/5 px-3">
                              <button className="bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 mr-5 rounded shadow-lg focus:outline-none mt-8">
                                 <i className="fas fa-plus mr-3" /> Crear Tipo Flor
                              </button>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
               <table className="table-fixed mt-3 w-full shadow-xl">
                  <thead>
                     <tr className="border border-orange-800 text-xs text-white content-center bg-orange-800">
                        <th className="text-center px-4 py-2" style={{ width: 60 }}></th>
                        <th className="px-4 py-2">Flor</th>
                        <th className="px-4 py-2">Variedad</th>
                        <td className="px-4 py-2">Color</td>
                        <th className="text-center" style={{ width: 400 }}>
                           Acciones
                        </th>
                     </tr>
                  </thead>
                  <tbody>
                     {tiposFlor.map((f, i) => {
                        return (
                           <tr key={i} className="text-sm">
                              <td className="border px-4 py-2">
                                 <button
                                    className="px-1 py-1 focus:outline-none mr-2"
                                    onClick={() => {
                                       mdlConfirmRef.current.showModal();
                                       setTipoFlor(f);
                                    }}
                                 >
                                    <i className="far fa-trash-alt" />
                                 </button>
                              </td>
                              <td className="border px-4 py-2">
                                 {f.flor}
                                 <ButtonIconLink
                                    iconClass="fas fa-edit"
                                    titulo="Editar Flor"
                                    disabled={false}
                                    history={props.history}
                                    to={"/editar_flor/" + f.florId}
                                 />
                              </td>
                              <td className="border px-4 py-2">{f.variedad}</td>
                              <td className="border px-4 py-2">{f.color}</td>
                              <td className="text-center border px-auto py-auto">
                                 <div className="inline flex-auto text-xs">
                                    <button
                                       className="text-white bg-orange-900 px-3 py-1 mr-1 rounded hover:bg-orange-700 focus:outline-none"
                                       onClick={() => {
                                          modalRef.current.tipoFlor(f);
                                          modalRef.current.showModal();
                                       }}
                                    >
                                       <i className="fas fa-edit"></i>
                                    </button>
                                    <ButtonIconLink
                                       iconClass="fas fa-upload"
                                       titulo="Imagen"
                                       history={props.history}
                                       to={"/imagen_flor/" + f.id}
                                    />
                                    <ButtonIconLink
                                       iconClass="fas fa-info-circle"
                                       titulo="Info/Ciclos"
                                       disabled={false /* ¿Se puede omitir?*/}
                                       history={props.history}
                                       to={"/info_flor/" + f.id}
                                    />
                                    <ButtonIconLink
                                       iconClass="fas fa-seedling"
                                       titulo="Labores"
                                       disabled={false /* ¿Se puede omitir?*/}
                                       history={props.history}
                                       to={"/labores/" + f.id}
                                    />
                                    <Button size='tiny' onClick={() => dispatch({ type: 'open', data: { ...f } })}><Icon name="plus" size='small' /> %</Button>
                                    {/*<ButtonIconLink
                                                    iconClass="fas fa-edit"
                                                    titulo="Editar"
                                                    disabled={false}
                                                    history={props.history}
                                                    to={"/editar_flor/" + f.id}
                                                />*/}
                                 </div>
                              </td>
                           </tr>
                        );
                     })}
                  </tbody>
               </table>
               {/* ---- ./CONTENIDO --- */}
            </div>
         </div>
         {/** loading **/}
         {loader && <MyLoader />}
         {/** ./loading **/}
         <ModalEditarVarColor ref={modalRef} fn={getTiposFlores} />

         {/** modal de confirmación */}
         <Modal
            titulo="Remover Tipo de Flor"
            mensaje={`¿Seguro de Remover ${tipoFlor.flor} ${tipoFlor.variedad} ${tipoFlor.color}?`}
            ref={mdlConfirmRef}
            actionTitle="Remover"
            actionFn={removerTipoFlor}
         />

         {/* Modal para regenerar los porcentajes de variedad y color */}
         <ModalSemantic open={ state.open } size='tiny' onClose={() => dispatch({ type: 'close', data: null, })}>
            <ModalSemantic.Header>Regenerar/Generar Porcentajes</ModalSemantic.Header>
            <ModalSemantic.Content style={{padding: '10px'}}>
               {state.data && 
                  <h5 className="ui dividing header">{state.data.flor} {state.data.variedad} {state.data.color}</h5>
               }
               <form className="ui form">
                  <div className="two wide fields">
                     <div className="field">
                        <label htmlFor="">Año:</label>
                        <select name="year" id="year" 
                                onChange={onChangeFrmPor}
                                className="ui dropdown">
                           <option value={ currentYear - 1 }>{ currentYear - 1 }</option>
                           <option value={ currentYear }>{ currentYear }</option>
                           <option value={ currentYear + 1 }>{ currentYear + 1 }</option>
                        </select>
                     </div>
                     <div className="field">
                        <Button type="button" positive style={{marginTop: '25px'}} onClick={() => generarPorcentajes( state.data )}>Generar</Button>
                     </div>
                  </div>
               </form>

               <div className="ui info message">
                  <div className="header">Nota:</div>
                  <p>Se Regenerará los porcentajes de la variedad y color, estos se pondran en ceros nuevamente!</p>
               </div>
            </ModalSemantic.Content>
            <ModalSemantic.Actions>
               <Button onClick={() => dispatch({ type: 'close' })}>
                  Cancelar
               </Button>
            </ModalSemantic.Actions>
         </ModalSemantic>

         {/** Toast */}
         <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
      </div>
   );
};

export default CatalogoArticulos;
